export default function ChevronDownIcon({ width = 32, height = 32, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33}
      height={32}
      style={{
        shapeRendering: 'geometricPrecision',
        textRendering: 'geometricPrecision',
        imageRendering: 'optimizeQuality',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      }}
      {...props}
    >
      <path
        fill="#fcfdfd"
        d="M10.5-.5h11c5.082 2.747 8.749 6.747 11 12v8c-2.251 5.253-5.918 9.253-11 12h-11c-5.082-2.747-8.749-6.747-11-12v-8c2.251-5.253 5.918-9.253 11-12Z"
        style={{
          opacity: 0.947,
        }}
      />
      <path
        fill="#2f383f"
        d="M11.5 14.5c.06-.543.393-.876 1-1a14.974 14.974 0 0 1 3.5 3c1.113-1.83 2.613-2.663 4.5-2.5L16 18.5a25.15 25.15 0 0 0-4.5-4Z"
        style={{
          opacity: 1,
        }}
      />
    </svg>
  );
}
